<template>
    <div id="menu">
        <div id="menuCont" :class="menuActive?'active':'deactive'">
            <div class="buttonCont main">
                <button class="menuItem" @click="this.menu = 'allgemein'"><span class="fa itemIcon">&#xf013;</span><span class="itemText">Allgemein</span></button>
                <button class="menuItem" @click="this.menu = 'account'"><span class="fa itemIcon">&#xf007;</span><span class="itemText">Account</span></button>
                <button class="menuItem" v-if="this.getSingleBerechtigung('feuerwehr_bearbeiten')" @click="$router.push('/feuerwehrverwaltung/'+this.$route.params.id)"><span class="fa itemIcon">&#xf1ad;</span><span class="itemText">Feuerwehr</span></button>
                <button class="menuItem" v-if="this.getSingleBerechtigung('benutzer_bearbeiten')" @click="$router.push('/benutzerverwaltung/'+this.$route.params.id)"><span class="fa itemIcon">&#xf0c0;</span><span class="itemText">Benutzer</span></button>
                <button class="menuItem" v-if="this.getSingleBerechtigung('fahrzeuge_bearbeiten')" @click="$router.push('/fahrzeugverwaltung/'+this.$route.params.id)"><span class="fa itemIcon">&#xf0d1;</span><span class="itemText">Fahrzeuge</span></button>
                <button class="menuItem" v-if="this.getSingleBerechtigung('geraete_bearbeiten')" @click="$router.push('/geraeteverwaltung/'+this.$route.params.id)"><span class="fa itemIcon">&#xf0ad;</span><span class="itemText">Geräte</span></button>
                <button class="menuItem" @click="$router.push('/datenschutz/'+this.$route.params.id)"><span class="fa itemIcon">&#xf023;</span><span class="itemText">Datenschutz</span></button>
                <button class="menuItem" @click="$router.push('/ueberdieapp/'+this.$route.params.id)"><span class="fa itemIcon">&#xf05a;</span><span class="itemText">Rechtliche Hinweise</span></button>

                <button v-if="this.routeParams != ':test'" class="menuItem" @click="this.logout()"><span class="fa itemIcon ausloggen">&#xf08b;</span><span class="itemText ausloggen">Ausloggen</span></button>
                <button v-if="this.routeParams == ':test'" class="menuItem" @click="this.logout()"><span class="fa itemIcon einloggen">&#xf090;</span><span class="itemText einloggen">Einloggen</span></button>
            </div>
            <div class="buttonCont allgemein" :class="this.menu == 'allgemein'?'menuActive':'menuDeactive'">
                <button class="menuItem" @click="this.menu = 'main'"><span class="fa itemIcon">&#xf104;</span><span class="itemText">Zurück</span></button>
                <button class="menuItem" @click="$router.push('/defaultwerte/'+this.$route.params.id)"><span class="fa itemIcon">&#xf2b9;</span><span class="itemText">Defaultwerte</span></button>
                <button class="menuItem" @click="this.requestFullscreen()"><span class="fa itemIcon">&#xf065;</span><span class="itemText">Vollbildschirm</span></button>
            </div>
            <div class="buttonCont account" :class="this.menu == 'account'?'menuActive':'menuDeactive'">
                <button class="menuItem" @click="this.menu = 'main'"><span class="fa itemIcon">&#xf104;</span><span class="itemText">Zurück</span></button>
                <button class="menuItem" @click="this.changePasswort()"><span class="fa itemIcon">&#xf084;</span><span class="itemText">Passwort ändern</span></button>
                <button class="menuItem" @click="this.logout()"><span class="fa itemIcon">&#xf0ec;</span><span class="itemText">Benutzer wechseln</span></button>
                <button class="menuItem" @click="this.benutzerLoeschen()"><span class="fa itemIcon">&#xf1f8;</span><span class="itemText">Account löschen</span></button>
            </div>
        </div>
    </div>
    <div id="bgCont" :class="menuActive?'bgActive':'bgDeactive'" @click="$emit('closeMenu')"></div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import {Benutzer} from '@/backend_controller/benutzer.js';
import { Berechtigung } from '@/backend_controller/berechtigung';

export default {
    name: 'menu',
    components: {
    },
    props:{
        menuActive: Boolean,
    },
    watch:{
        menuActive(newVal, oldVal){
            if(newVal == false){
                this.menu = 'main';
            }
        },
        '$route.params.id': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.setBerechtigungen(newVal);
                }
            }
        }
    },
    data() {
      return{
        routeParams: String,
        menu: 'main',
        fullscreen: false,
        berechtigungen: [],
      }
    },
    
    methods:{
        async setBerechtigungen(routeParams){
            console.log(routeParams);
            if(routeParams == undefined || routeParams == null || routeParams == ""){
                return false;
            } else if(routeParams.replace(":", "") == "test"){
                return false;
            }
            const response = await Berechtigung.get(routeParams.replace(":", ""));
            this.berechtigungen = response;
            this.$emit('updateBerechtigungen', this.berechtigungen);
            return this.berechtigungen;
        },
        getSingleBerechtigung(berechtigungName){
            if(this.berechtigungen == undefined || this.berechtigungen == null || this.berechtigungen.length == 0 || !this.berechtigungen){
                return false;
            }
            return this.berechtigungen.find(berechtigung => berechtigung.name === berechtigungName);
        },
        logout(){
            console.log(this.routeParams)
            localStorage.clear();
            this.$router.push('/');
        },
        enterFullscreen(element) {
        if(element.requestFullscreen) {
            element.requestFullscreen();
        } else if(element.msRequestFullscreen) {      // for IE11 (remove June 15, 2022)
            element.msRequestFullscreen();
        } else if(element.webkitRequestFullscreen) {  // iOS Safari
            element.webkitRequestFullscreen();
        }
        },
        isBrowser(){
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if ((userAgent.includes("Chrome") || userAgent.includes("Safari") || userAgent.includes("Firefox") || userAgent.includes("Edge")) && typeof window.cordova == "undefined") {
            return true;
        } else {
            return false;
        }
        },
        requestFullscreen(){
            if(!this.fullscreen){
                if(this.isBrowser()){
                Swal.fire({
                    title: "Anwendung im Vollbild starten",
                    showDenyButton: true,
                    confirmButtonText: "Ja",
                    denyButtonText: `Nein`
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                    this.enterFullscreen(document.documentElement)
                    this.fullscreen = true;
                    } else if (result.isDenied) {
                    this.fullscreen = false;
                    }
                });
                }
            } else{
                document.exitFullscreen();
                this.fullscreen = false;
            }
        },
        async changePasswort(){
            Swal.fire({
                title: "Neues Passwort",
                input: "password",
                showCancelButton: true,
                confirmButtonText: "Weiter",
                preConfirm: (eingabe) => {
                return eingabe;
                }
            }).then((result) => {
                if(result.isConfirmed){
                this.passwortWdh(result.value);
                }
            });
        },
        async passwortWdh(passwort){
            if(passwort){
                Swal.fire({
                title: "Passwort wiederholen",
                input: "password",
                showCancelButton: true,
                confirmButtonText: "Speichern",
                preConfirm: (eingabe) => {
                return eingabe;
                }
            }).then((result) => {
                if(result.isConfirmed){
                if(passwort != result.value){
                    this.unterschiedlichePasswoerter();
                } else{
                    this.passwortSpeichern(result.value);
                }
                }
            });
            }
        },
        async unterschiedlichePasswoerter(){
            await Swal.fire("Passwort konnte nicht gespeichert werden", "Sie haben unterschiedliche Passwörter eingegeben", "error");
            this.changePasswort();
            },
        async passwortSpeichern(passwort){
            var benutzer = await this.getBenutzer(this.$route.params.id.replace(":", ""));
            console.log(benutzer);
            if(await this.updateBenutzer(benutzer.email, passwort, benutzer.konvKey, benutzer.feuerwehrID, benutzer.freigeschalten, benutzer.vorname, benutzer.nachname)){
                await Swal.fire("Passwort erfolgreich gespeichert", "", "success");
            } else{
                await Swal.fire("Fehler", "Bitte versuchen Sie es später erneut", "error");
            }
        },
        async getBenutzer(konvKey) {
            const response = await Benutzer.getSingleWithKonvKey(konvKey);

            if(response == false){
                return false;
            } else{
                return response;
            }
        },
        async updateBenutzer(email, passwort, konvKey, feuerwehrID, freigeschalten, vorname, nachname){
            const benutzerData = {
                email: email,
                passwort: passwort,
                konvKey: konvKey,
                feuerwehrID: feuerwehrID,
                freigeschalten: freigeschalten,
                vorname: vorname,
                nachname: nachname
            };
            console.log(benutzerData);

            const response = await Benutzer.update(benutzerData);
            
            if(response == true){
                return true;
            } else{
                return false;
            }
        },
        async benutzerLoeschen(){
            Swal.fire({
                title: "Account wirklich löschen?",
                showDenyButton: true,
                confirmButtonText: "Ja, löschen",
                denyButtonText: `Nicht löschen`,
                }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteBenutzer();
                } 
            });
        },
        async deleteBenutzer(){
            var benutzer = await this.getBenutzer(this.$route.params.id.replace(":", ""));

            const response = await Benutzer.delete(benutzer.email);

            if(response == true){
                await Swal.fire("Account erfolgreich gelöscht", "", "success");
                this.logout();
            } else{
                await Swal.fire("Fehler", "Bitte versuchen Sie es später erneut", "error");
            }
        }
    },
    async created(){
        this.berechtigungen = await this.setBerechtigungen();
    },
    mounted() {
        this.routeParams = this.$route.params.id;
    },
}
</script>

<style lang="scss" scoped>
#menu{
    width: 90vw;
    height: 100vh;
    z-index: 20;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    pointer-events: none;

    #menuCont{
        background-color: white;
        width: 80vw;

        .buttonCont{
            position: fixed;
            top: 15vh;
            height: 85vh;
            width: 80vw;
            background-color: white;

            .menuItem{
                background-color: transparent;
                width: 100%;
                height: 2.7rem;
                text-align: left;
                border: none;
                padding-left: 1.5rem;
                font-size: medium;
                display: flex;
                align-items:center;

                .itemText{
                    margin-left: 0.7rem;
                }

                .itemIcon{
                    font-size: x-large;
                    width: 1.5rem;
                }
            }

            .menuItem:hover{
                cursor: pointer;
                background-color:rgba(0, 0, 0, 0.103);
            }
        }
    }
}

#bgCont{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 19;
    pointer-events: none;
}

.bgDeactive{
    background-color: transparent;
    transition: background-color 0.3s;
    pointer-events: none;
}

.bgActive{
    background-color: rgba(0, 0, 0, 0.315);
    transition: background-color 0.3s;
    pointer-events:auto !important;
}

.deactive{
    transform:translateX(-100vw);
    transition: transform 0.3s;
    pointer-events: none;
}

.active{
    transform: translateX(0);
    transition: transform 0.3s;
    pointer-events: auto !important;
}

.ausloggen{
    color: red;
}

.einloggen{
    color: green;
}

.menuActive{
    transform:translateX(0);
    transition: transform 0.5s;
    z-index: 20;
}

.menuDeactive{
    transform:translateX(-80vw);
    transition: transform 0.5s;
    z-index: 19;
}
</style>